
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"11.802","height":"16.002"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"그룹 1164","transform":"translate(-695.859 -441.425)"}},[_c('rect',{attrs:{"data-name":"사각형 1666","width":"9.802","height":"14.002","rx":"1","transform":"translate(696.859 442.425)","fill":"none","stroke":"#e66a1f","stroke-width":"2"}}),_c('rect',{attrs:{"data-name":"사각형 1667","width":"2.1","height":"2.1","rx":"1","transform":"translate(698.96 444.525)","fill":"#e66a1f"}}),_c('rect',{attrs:{"data-name":"사각형 1779","width":"2.1","height":"2.1","rx":"1","transform":"translate(698.96 448.026)","fill":"#e66a1f"}}),_c('rect',{attrs:{"data-name":"사각형 1668","width":"2.1","height":"2.1","rx":"1","transform":"translate(702.46 444.525)","fill":"#e66a1f"}}),_c('rect',{attrs:{"data-name":"사각형 1669","width":"2.1","height":"2.1","rx":"1","transform":"translate(702.46 448.026)","fill":"#e66a1f"}}),_c('path',{attrs:{"data-name":"사각형 1781","d":"M701.36 452.927h.8a1 1 0 011 1v2.5h-2.8v-2.5a1 1 0 011-1z","fill":"#e66a1f"}})])])
          )
        }
      }
    